module.exports = __webpack_public_path__ + "static/media/congrats.ad4ff122.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Confirmation/img/congrats.jpg
// module id = 971
// module chunks = 0